import { LocalizationKeys, type LocalizationKey } from '../../i18n/keys'

/**
 * Theme enum
 */
export enum Theme {
  UNSPECIFIED = 0,
  LIGHT = 1,
  DARK = 2,
}

/**
 * Мапинг Theme enum на ключи локализации
 */
export const THEME_I18N_KEYS: Record<Theme, LocalizationKey> = {
  [Theme.UNSPECIFIED]: LocalizationKeys.THEME_SYSTEM,
  [Theme.LIGHT]: LocalizationKeys.THEME_LIGHT,
  [Theme.DARK]: LocalizationKeys.THEME_DARK,
} as const
